import { render, staticRenderFns } from "./ExtendOtherNutrientsIodine.vue?vue&type=template&id=e3e3f002&scoped=true"
import script from "./ExtendOtherNutrientsIodine.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsIodine.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsIodine.vue?vue&type=style&index=0&id=e3e3f002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e3f002",
  null
  
)

export default component.exports